module.exports = __webpack_public_path__ + "static/media/logo_white_2.723f04d8.png";